import 'css-chunksrc/client/pages/projectPage/discussionsPage/discussions/discussion/comment/reply/styles.scss';export default {
  "reply": "_reply_1a9ha_1",
  "iconBox": "_iconBox_1a9ha_12",
  "icon": "_icon_1a9ha_12",
  "avatar": "_avatar_1a9ha_31",
  "main": "_main_1a9ha_37",
  "header": "_header_1a9ha_41",
  "author": "_author_1a9ha_48",
  "date": "_date_1a9ha_54",
  "content": "_content_1a9ha_60"
};